/* global $ */
/* global gettext */
/* global tagcommander */

/**
 *
 * @todo stop using viewerUI for batch control.
 */
(function (sculpteo) {
  "use strict";

  var PrintController = (sculpteo.PrintController = function (
    design,
    materials,
    listOfUrls,
    optionsHollowing
  ) {
    this.materials = new sculpteo.PrintMaterialCollection(
      this,
      materials,
      design
    );
    this.design = design;
    this.prices = null;
    this.addToCartUrl = listOfUrls.addToCartUrl;

    //hold the error if there is one after getting the price
    //can only be one error at a time
    this.error = null;
    //hold a list of warnings if there is at least one after getting the price
    this.warnings = null;

    //current language
    this.lang = $("html").attr("lang");

    //current selected tool
    this.currentTool = sculpteo.PrintToolsView.TOOLS.DASHBOARD;

    // Initialize views
    this.views = {};

    this.views.price = new sculpteo.PrintPriceView(this, this.design);
    // staff only
    if (window.isStaff) {
      this.views.informations = new sculpteo.PrintStaffInformationsView(
        this,
        this.design
      );
    }
    this.views.settings = new sculpteo.PrintSettingsView(
      this,
      this.design,
      this.materials,
      this.texts
    );
    this.views.tools = new sculpteo.PrintToolsView(this, this.design);
    this.views.notification = new sculpteo.PrintNotificationView(
      this,
      this.design
    );

    this.views.overlayNotification = new sculpteo.PrintOverlayNotification(
      this
    );
  });

  /**
   * Parses delivery errors and copies them to priceData.error so that they can be handled by downstream code
   */
  PrintController.prototype.parseDeliveryErrors = function (priceData, design) {
    var delivery = priceData.delivery;
    if (design.order.finish && priceData.options && priceData.options.finish) {
      delivery = priceData.options.finish[design.order.finish].delivery;
    }
    if (
      delivery !== undefined &&
      (delivery.nb_printers == "-1" || delivery.nb_printers == "n/a")
    ) {
      // see SchedulingError enum in constants
      if (priceData.delivery.error && priceData.delivery.error == 1) {
        priceData.error = gettext(
          "Lead times cannot be automatically computed please contact the commercial team"
        );
        priceData.error_info = {
          ID: "no_delays_available",
          data: priceData.error,
          text: "",
        };
      } else {
        priceData.error =
          gettext("No printer available for this material") +
          ":<br>" +
          design.material.name;
        //simulate how the error works in gallery/models.py  line:3256
        priceData.error_info = {
          ID: "no_printer_available",
          data: priceData.error,
          text: "",
        };
      }
    }
  };

  /**
   * handles loading. Hide/show price and setting
   *
   * @public
   * boolean
   */
  PrintController.prototype.setLoading = function (status, message) {
    this.views.price.enabled(!status);
    this.views.settings.enabled(!status);
  };

  /**
   * handles settings show/hide
   *
   * @public
   * boolean
   */
  PrintController.prototype.toggleSettingsVisibility = function (status) {
    this.views.settings.enabled(status);
  };

  /**
   * check error
   *
   * @public
   */
  PrintController.prototype.checkError = function (errorCode) {
    if (this.error === null) {
      return false;
    }
    if (errorCode === this.error.ID) {
      return true;
    }
    return false;
  };

  /**
   * check warning
   *
   * @public
   */
  PrintController.prototype.checkWarning = function (warningCode) {
    if (this.warnings === null) {
      return false;
    }
    for (var i = 0; i < this.warnings.length; i++) {
      if (warningCode === this.warnings[i].ID) {
        return true;
      }
    }
    return false;
  };

  PrintController.prototype.updateProductionMode = function (
    production_mode
  ) {};

  /**
   * Updates used currency and re-compute prices
   *
   * @public
   * @param {string} currency - EUR, GBP, USD
   * @param {string} symbol - €, £, $
   */
  PrintController.prototype.updateCurrency = function (currency, symbol) {
    this.design.order.currency = currency;
    this.design.order.currency_symbol = symbol;
    this.materials.clearPrices();
    this.updatePriceForSelectedMaterial();
    this.updateMaterialList();

    this.views.price.currencyChanged();

    if (window.GoogleTagManager) {
      window.GoogleTagManager.sendTag({
        category: "print",
        action: "print.currency",
        value: currency,
      });
    }
  };

  /**
   * Reload material and prices from the server to update their availabili
   *
   * List is updated when:
   * - At loading
   * - Scale is modified
   * - Unit is modified
   */
  PrintController.prototype.updateMaterialList = function () {
    var deferred = $.Deferred();
    this.materials.is_fetching_all_materials = true;

    this.materials.computePricesAndDelays(false).then(
      function () {
        this.materials.is_fetching_all_materials = false;
        this.views.settings.updateSelectors();

        if (this.views.materials) {
          this.views.materials.updateSelectors();
        }
        deferred.resolve();
      }.bind(this)
    );

    return deferred;
  };

  /**
   * execute the request to add the design to the cart, redirect to cart on success
   */
  PrintController.prototype.addToCart = function () {
    var data = {
      uuid: this.design.model_uuid,
      unit: this.design.size.unit,
      scale: this.design.size.userScale,
      quantity: this.design.order.quantity,
      currency: this.design.order.currency,
      ensemble: 0,
      registered: 1, // design will be saved in user's gallery
      material: this.design.material.id,
      infill: this.materials.getInfill(this.design),
      finish: this.design.order.finish || "",
      painting: this.design.order.painting || "",
      color: this.design.order.color || "",
      production_mode: this.design.order.production_mode || "",
      fixed_orientation: this.design.order.fixed_orientation ? "1" : "0",
      page_origin: "print_new",
    };
    const $details_form = $(".PrintDetailsForm");
    if ($details_form.length) {
      data.details = $details_form.serialize();
    } else {
      data.details = "";
    }

    this.views.price.setAddToCartLoading();

    this.setLoading(true);
    this.overlayNotify(
      sculpteo.PrintOverlayNotification.TYPE.INFO,
      gettext("Adding your design to cart"),
      false
    );

    $.post(this.addToCartUrl, data).done(
      function (response) {
        if (response.message) {
          this.setLoading(false);
          this.notify("error", response.message);
        } else {
          if (window.theme)
            return (window.location =
              window.URL_PREFIX + "t/" + window.theme + "/shop/cart/");
          window.location = response.cart;
        }
      }.bind(this)
    );
  };

  /**
   * Format price with the good decimal separator and currency symbol
   * @private
   * @param {float} price
   * @param {bool} withoutCurrency
   */
  PrintController.prototype.formatPrice = function (price, withoutCurrency) {
    if (!price) {
      return "---";
    }

    if (this.lang === "en") {
      return (
        (!!withoutCurrency ? "" : this.design.order.currency_symbol + " ") +
        this.design.order.format_price(price)
      );
    }

    return (
      this.design.order.format_price(price) +
      (!!withoutCurrency ? "" : " " + this.design.order.currency_symbol)
    );
  };

  /**
   * Proxy method to notify something in the notification view
   * @param {string} type
   * @param {string} id
   * @param {bool} autoHide
   * @param {string} data - dynamics string usually generate server side - optional (default: undefined)
   */
  PrintController.prototype.notify = function (type, id, autoHide, data) {
    if (["error", "warn", "info"].indexOf(type) > -1) {
      this.views.notification[type](id, !!autoHide, data);
    }
  };

  /**
   * Proxy method to notify something in the overlay notification view
   * @param {string} type
   * @param {string} message
   * @param {bool} autoHide
   */
  PrintController.prototype.overlayNotify = function (type, message, slow) {
    this.views.overlayNotification.notify(type, message, slow);
  };
})((window.sculpteo = window.sculpteo || {}));
